import { LineItemDTO } from '@services/DTO/LineItemDTO'

export class OrderDTO {
    constructor(
        public id: string,
        public venueId: string,
        public lineItems: LineItemDTO[],
        public currencyCode: string,
        public message: string | null,
        public dateCreated: string,
        public dateUpdated: string,
        public isPaid: boolean = false
    ) { }
}
